import React, { useEffect, useState } from "react";
import { SelectBox } from "devextreme-react/select-box";
import { useFetch } from "@hooks/useBatchIntakeApi";
import { Button, TextBox } from "devextreme-react";
import { Height } from "devextreme-react/cjs/chart";

const MonitorDropdownFilters = ({
  suppliers,
  batches,
  getBatch,
  setMonitorView,
  setSupplier,
  supplier,
  batch,
  setBatchData,
  setSupplierName,
  value,
  setValue,
  isPidExist,
  setIsPidExist,
  setIsDateRangeExist,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setBatchInfo,
  setSelectedFilter,
  setPid,
  isDateRangeExist,
  loader,
  setProcessImagesData,
  selectedFilter,
  setIsActual,
  isActual,
}) => {
  const [isToday, setIsToday] = useState(false);

  const options = [
    { id: 1, name: "Multi View" },
    { id: 2, name: "Dual View" },
    { id: 3, name: "Triple View" },
  ];

  const handleValueChange = (e) => {
    const newValue = e.value;
    setValue(newValue);

    // Detect clear button click
    if (newValue === "") {
      // console.log('Clear button clicked!');
      setIsPidExist(false);
      // Your custom logic here
    }
  };

  return (
    <React.Fragment>
      <div className="w-full flex lg:flex-row  flex-col lg:items-center gap-2">
        <Button
          style={{ height: "38px" }}
          disabled={isActual}
          className="px-2 py-1 text-center w-[100px]"
          onClick={() => {
            const todayStart = new Date();
            todayStart.setUTCHours(0, 0, 0, 0);
            const todayEnd = new Date();
            todayEnd.setUTCHours(23, 59, 0, 0);
            setStartDate(todayStart);
            setEndDate(todayEnd);
            setIsToday(true);
            setSupplier(null);
            setBatchInfo(null);
            setIsPidExist(false);
            setPid(null);
            setIsDateRangeExist(false);
            setIsActual(true);
            setSelectedFilter(() => "actual");
          }}
        >
          {"Actual"}
        </Button>
        <SelectBox
          dataSource={suppliers}
          displayExpr="name" // Display text
          valueExpr="supplierID" // Value field
          value={parseInt(supplier)}
          searchEnabled={true}
          onValueChanged={(e) => {
            setSupplier(e.value);
            setBatchData(null);
            setSupplierName(e?.component?.option("text")); // Store supplier name in localStorage
            localStorage.setItem("supplierName", e?.component?.option("text"));
            // setStartDate(null);
            // setEndDate(null);
            // setIsToday(false);
            // setIsActual(false);
          }}
          placeholder="Select Supplier"
        />
        <SelectBox
          dataSource={batches}
          displayExpr="batchNumber" // Display text
          valueExpr="batchNumber" // Value field
          searchEnabled={true}
          showClearButton={true}
          value={batch}
          onValueChanged={(e) => {
            getBatch(e.value);
            const matchedBatch = batches?.find(
              (batch) => batch.batchNumber === e.value
            );
            console.log("matchedBatch", matchedBatch, e);
            setBatchData(matchedBatch);
            setProcessImagesData([]);
            // setIsActual(false);
            // localStorage.setItem("batchNum", e?.component?.option("text")); // Store supplier name in localStorage
          }}
          placeholder="Select Batch"
          itemRender={(item) => (
            <span style={item?.hasProcessedData ? { color: "green" } : {}}>
              {item?.batchNumber}
            </span>
          )}
        />
      </div>
    </React.Fragment>
  );
};

export default MonitorDropdownFilters;
